import { useEffect, useState } from 'react';
import { apiFetch } from '../network';

function normalizeEvents(payload) {
  if (Array.isArray(payload?.events)) {
    return payload.events;
  }

  if (Array.isArray(payload?.Evenements)) {
    return payload.Evenements;
  }

  return [];
}

export function useEvents() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const refreshEvents = async () => {
    setLoading(true);
    setError(false);

    try {
      const response = await apiFetch('/evenements/get');

      if (!response.ok) {
        throw new Error('request_failed');
      }

      const data = await response.json();
      setEvents(normalizeEvents(data));
    } catch (requestError) {
      setEvents([]);
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshEvents();
  }, []);

  return {
    events,
    loading,
    error,
    refreshEvents
  };
}
